{
  //handle button clicks
  document.querySelectorAll('.tabbed-alternating-content--filter').forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()

      const container = button.closest('.tabbed-alternating-content')
      const label = button.textContent.trim()
      const showAll = label === 'All'

      // Update active state
      container.querySelectorAll('.tabbed-alternating-content--filter').forEach(btn => {
        btn.setAttribute('aria-pressed', btn === button)
      })

      // Show/hide rows
      container.querySelectorAll('[data-category-filter]').forEach(row => {
        const visible = showAll || row.getAttribute('data-category-filter') === label
        row.style.display = visible ? '' : 'none'
      })

      // Focus first focusable element in the first visible row
      window.requestAnimationFrame(() => {
        const firstVisible = [...container.querySelectorAll('[data-category-filter]')].find(row => row.style.display !== 'none')
        firstVisible?.querySelector('a, button, input, [tabindex]')?.focus()
      })
    })
  })
}